import uniqueId from 'lodash-es/uniqueId'
import { finishCloseModal, startCloseModal, updateModal } from '../../actions/app'
import { Loader } from '.'

const ModalHeader = ({ title, showCloseButton }) => (
  <div className="modal-header">
    {showCloseButton ? (
      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
    ) : null}
    {title ? <h4 className="modal-title">{title}</h4> : null}
  </div>
)

// actions = { isDismissable, onClick, isPrimary, buttonLabel, isDisabled }
const ModalFooter = ({ actions, unsetModalIsCancelled }) => (
  <div className="modal-footer">
    {actions.map(a => {
      const dismissable = a.isDismissable ? { 'data-dismiss': 'modal' } : {}
      return (
        <button
          type="button"
          key={uniqueId()}
          onClick={() => {
            if (!a.onClick) return
            unsetModalIsCancelled()
            a.onClick()
          }}
          className={`btn btn-sm ${a.isPrimary ? 'btn-primary' : 'btn-secondary'}`}
          {...dismissable}
          disabled={a.isDisabled}
          style={{ position: 'relative' }}
        >
          {a.buttonLabel}
          {a.busy && (
            <Loader size="sm" style={{ position: 'absolute', top: '12px', right: '10px' }} />
          )}
        </button>
      )
    })}
  </div>
)

const mapStateToProps = state => ({
  isLoggedIn: state.user.isAuthed,
  modal: state.app.modal,
  breakpoint: state.app.breakpoint.name,
})
const mapDispatchToProps = dispatch =>
  bindActionCreators({ startCloseModal, finishCloseModal, updateModal }, dispatch)

class Modal extends Component {
  constructor(props) {
    super()
    this.modalName = props.modal.name
    this.modalIsCancelled = true
  }

  componentDidMount() {
    const { finishCloseModal, onCloseAction, onCancelOnlyAction, breakpoint } = this.props

    this.$modal.modal()
    this.$modal.on(
      'hidden.bs.modal',
      function (e) {
        onCloseAction && onCloseAction() // Called every time a modal is dismissed
        this.props.modalCloseFocusElem && this.props.modalCloseFocusElem.focus()
        finishCloseModal(this.modalName)
      }.bind(this)
    )

    this.$modal.on(
      'hide.bs.modal',
      function (e) {
        this.modalIsCancelled && onCancelOnlyAction && onCancelOnlyAction() // Called only if onCancelOnlyAction exists and dismissing action does not have an associated click value
      }.bind(this)
    )

    this.IOS11WorkAroundForInputFocusBug(true)
  }

  componentWillUnmount() {
    this.$modal && this.$modal.modal('hide')
    this.IOS11WorkAroundForInputFocusBug()
  }

  IOS11WorkAroundForInputFocusBug(show) {
    // https://stackoverflow.com/questions/46339063/ios-11-safari-bootstrap-modal-text-area-outside-of-cursor
    const smallBreakpoint = this.props.breakpoint === 'mobile' || this.props.breakpoint === 'tablet'
    document.body.style.position = show && smallBreakpoint ? 'fixed' : 'relative'
  }

  componentDidUpdate(prevProps) {
    const { startCloseModal, isLoggedIn, shouldCloseModal, children, updateModal } = this.props
    if (shouldCloseModal || !isLoggedIn) {
      startCloseModal()
      this.$modal.modal('hide')
    }

    if (children.type !== prevProps.children?.type) {
      updateModal()
    }
  }

  shouldComponentUpdate(nextProps) {
    return !nextProps.modal.transitioning
  }

  unsetModalIsCancelled() {
    this.modalIsCancelled = false
  }

  render() {
    const {
      headerTitle,
      children,
      footerActions,
      noHeader,
      hideCloseButton,
      isVideoModal,
      onCancelOnlyAction,
      modalStyles = {},
      modalClass,
    } = this.props
    const bodyClasses = `modal-content${!footerActions ? ' cb-no-footer' : ''}${
      noHeader ? ' cb-no-header' : ''
    }`

    return (
      <div
        className={`modal fade cb-modal-animation ${isVideoModal ? 'cb-video-modal' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label={headerTitle}
        aria-describedby="modalBody"
        tabIndex="-1"
        ref={modal => {
          this.$modal = $(modal)
        }}
      >
        <div className={`modal-dialog ${modalClass || ''}`} role="document" style={modalStyles}>
          <div className={bodyClasses}>
            {!noHeader ? (
              <ModalHeader title={headerTitle} showCloseButton={!hideCloseButton} />
            ) : null}

            <div className="modal-body" id="modalBody">
              {children}
            </div>

            {footerActions ? (
              <ModalFooter
                actions={footerActions}
                unsetModalIsCancelled={this.unsetModalIsCancelled.bind(this)}
              />
            ) : null}
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal)
